import Api from "../api";
import qs from "qs";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";
import { IConsumableRepository } from "./ConsumablesRepository.types";
import { IConsumables, IConsumablesListItem, ConsumablesListItemResponseType, ConsumablesResponseType } from "@/entity/consumables/consumables.types";
import Consumables from "@/entity/consumables/consumables";
import { ServiceGeneralProductsCreateRequestType } from "@/form/serviceGeneral/serviceGeneralProductsCreate.types";

export class ConsumablesRepository implements IConsumableRepository{

    async fetchAll(data?: FormData): Promise<IConsumables>{

        const response = await Api.get('/consumable/get', {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString()
        }});

        const responseData = response.data as ConsumablesResponseType;

        return new Consumables(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IConsumablesListItem> {

        const response = await Api.get(`/consumable/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as ConsumablesResponseType;

        return new Consumables(responseData).data[0];
    }

    async create(data: ServiceGeneralProductsCreateRequestType): Promise<ResponseDataType> {

        const response = await Api.post(`/consumable/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: ServiceGeneralProductsCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/consumable/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/consumable/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}